<template>
  <div class="profile-page">
    <!-- 顶部用户信息栏 -->
    <van-cell class="user-header">
      <div class="avatar-wrapper" slot="title">
        <van-image width="60" height="60" round :src="avatar" class="avatar" />
        <span class="username">{{ username }}</span>
      </div>
    </van-cell>

    <!-- 个人信息分组 -->
    <van-cell-group inset class="info-group">
      <div class="group-title">个人信息</div>
      <van-cell title="头像" is-link/>
      <van-cell title="昵称" is-link />
      <van-cell title="手机号码" is-link />
      <van-cell title="地址管理" is-link  />
    </van-cell-group>

    <!-- 底部退出登录按钮 -->
    <div class="logout-wrapper">
      <van-button type="primary" block round >
        退出登录
      </van-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "my",
  props: {
    datas: Object,
  },
  data() {
    return {
      avatar: require("@/assets/avatar.png"), // 可替换为实际头像地址
      username: "松间春未散",
    };
  },
  created() {},
  methods: {
    // 点击我的组件
    // clickMy() {
    //     if (this.myData.linkType === "10") {
    //         // 内部链接
    //         this.$router.push({
    //             path: this.myData.internalLink,
    //         });
    //     } else if (this.myData.linkType === "11") {
    //         // 外部链接
    //         window.open(this.myData.externalLink);
    //     }
    // }
  },
};
</script>

<style scoped lang="scss">
.profile-page {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-color: #fff;
  background-size: contain;
  background-image: url(@/assets/center.png);
}

/* 顶部用户信息栏 */
.user-header {
  margin: 50px 30px 0 30px;
  background-color: transparent !important;
  // background: linear-gradient(135deg, #66a6ff 0%, #a18cd1 100%);
  padding: 20px 16px;
  margin-bottom: 10px;

  .avatar-wrapper {
    display: flex;
    align-items: center;
    .avatar {
      margin-right: 12px;
    }
    .username {
      font-size: 16px;
      font-weight: 500;
      color: #323232;
    }
  }
}

/* 个人信息分组 */
.info-group {
  .group-title {
    padding: 12px 16px;
    font-size: 14px;
    color: #646566;
  }
}

/* 底部退出登录按钮 */
.logout-wrapper {
  padding: 40px 16px;
  margin: 170px 50px;
  .van-button {
    background-color: #1989fa;
    border-color: #1989fa;
  }
}
</style>
